import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M4 22V20H20V22H4ZM12 19L8 15L9.4 13.6L11 15.15V8.85L9.4 10.4L8 9L12 5L16 9L14.6 10.4L13 8.85V15.15L14.6 13.6L16 15L12 19ZM4 4V2H20V4H4Z" />
  </>,
  "LimitChange",
);

export default Icon;
